import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import LeadStatusOption from 'components/dropdowns/Lead/LeadStatus'
import LeadTypeOption from 'components/dropdowns/Lead/LeadType'
import LeadStageOption from 'components/dropdowns/Lead/LeadStatge'
import LeadSourceOption from 'components/dropdowns/Lead/LeadSource'
import OtherDropdowns from "components/dropdowns/Other/OtherDropdowns"
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import SaveButton from "components/buttons/save"
import RsLink from "components/buttons/rsLink"
import {Row,Col,FormGroup,Label} from "reactstrap"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import moment from "moment-timezone";
import Select from "react-select"
import axios from "axios"
import { API_URL } from "helpers/app_url"
import { toast } from "react-toastify"
import PhoneInputField from "components/dropdowns/PhoneInputField"
import CurrencyInput from "react-currency-input-field";
import SafeField from "helpers/SafeField";
class ConvertToLead extends Component {
  constructor(props) {
    super(props)
    this.state = {
      optionGroup1:[]
    }
    this.handleSubmitLead = this.handleSubmitLead.bind(this);
  }
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  handleSubmitLead = async (values, actions) => {
    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      
      if (!token) {
        console.error("Token not found!");
        toast.error("Authentication failed. Please log in again.");
        return;
      }
  
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      // Construct the payload for lead submission
      const payload = {
        openhouseLeadId: parseInt(values.openhouseLeadId, 10) || 0,
        firstName: values.firstName,
        lastName: values.lastName,
        leadStatusId: parseInt(values.leadStatusId, 10) || 0,
        leadTypeId: parseInt(values.leadTypeId, 10) || 0,
        leadSourceId: parseInt(values.leadSourceId, 10) || 14,
        email: values.email,
        phone: values.phone,
        phoneExt: values.phoneExt,
        mobile: values.mobile,
        agentId: parseInt(localStorage.getItem("userId"), 10) || 0,
        group: parseInt(values.group, 10) || 0,
        approxDealValue: parseInt(values.approxDealValue, 10) || 0,
        notes: values.notes,
        submittedDate: moment(values.submittedDate).format("YYYY-MM-DD"),
        title: values.title,
        stageId: parseInt(values.stageId, 10) || 0,
        fullAddress: values.fullAddress,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        nearestIntersection: values.nearestIntersection,
        city: values.city,
        province: values.province,
        postal: values.postal,
        country: values.country,
        longitude: values.longitude,
        latitude: values.latitude,
      };

      toast.loading("Submitting Lead...");
      const leadResponse = await axios.post(`${API_URL}ClientOpenhouseLead/ConvertOpenhouseLeadToLead`, payload, { headers });
  
      if (leadResponse.data.success) {
        toast.dismiss();
        toast.success("Lead Converted successfully!");
        this.props.toggleConvertLead();
      } else {
        toast.dismiss();
        toast.error("Failed to converted lead.");
      }
    } catch (error) {
      toast.dismiss();
      console.error("Error submitting lead:", error.response?.data || error.message);
    }
  };
  
  componentDidMount() {
    
  }

  
  render() {
    const { toggleConvertLead, lead } = this.props;
    const { optionGroup1, isLoading } = this.state;
    return (
      <React.Fragment>
          
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          openhouseLeadId: lead.id || 0,
                          
                          firstName: lead.firstName || "",
                          lastName: lead.lastName || "",
                          email: lead.email || "",
                          phone: lead.phone || "",
                          phoneExt: lead.phoneExt || "",
                          mobile: lead.mobile || "",
                          leadStatusId:"",
                          fullAddress:'',
                          addressLine1:'',
                          addressLine2:'',
                          nearestIntersection:'',
                          city:'',
                          province:'',
                          postal:'',
                          country:'',
                          longitude:0,
                          latitude:0, 
                          leadSourceId: 14,  
                          submittedDate: new Date(),
                        }}
                        validationSchema={Yup.object().shape({
                          //title: Yup.string().required('This field is required'),
                          firstName: Yup.string().required("This Field in required"),
                          lastName: Yup.string().required("This Field in required"),
                          email: Yup.string().email('Invalid email').required('This Field in required'),
                          mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                          phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                        })}

                        onSubmit={this.handleSubmitLead}
                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="submittedDate">
                                    {this.props.t("Submitted Date")}
                                  </Label>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.submittedDate && touched.submittedDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.submittedDate}
                                    onChange={(value) => setFieldValue('submittedDate', value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="firstName">
                                    {this.props.t("First Name *")}
                                  </Label>
                                  <SafeField
                                    name="firstName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.firstName && touched.firstName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="firstName"
                                  />
                                  <ErrorMessage
                                    name="firstName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>

                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="lastName">
                                    {this.props.t("Last Name *")}
                                  </Label>
                                  <SafeField
                                    name="lastName"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.lastName && touched.lastName
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="lastName"
                                  />
                                  <ErrorMessage
                                    name="lastName"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md="12">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="fullAddress">
                                            {this.props.t("Location")}
                                          </Label>


                                          <PlacesAutocomplete
                                             value={values.fullAddress}
                                             onChange={(value) => setFieldValue('fullAddress', value)}
                                            onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                          >
                                       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                  <div>
                                                    <input
                                                      {...getInputProps({
                                                        placeholder: 'Enter Address...',
                                                        className: 'form-control',
                                                      
                                                      })}
                                                    />
                                                    <div className="">
                                                      {loading ? <div>Loading...</div> : null}

                                                      {suggestions.map((suggestion, i) => {
                                                        const className = suggestion.active
                                                          ? 'suggestion-item--active'
                                                          : 'suggestion-item';
                                                        const style = suggestion.active
                                                          ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                          : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                                        return (
                                                          <div
                                                          key={i}
                                                            {...getSuggestionItemProps(suggestion, {
                                                              style,
                                                            })}
                                                          >
                                                            {suggestion.description}
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </PlacesAutocomplete>


                                        </FormGroup>
                                      </Col>
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="email">
                                    {this.props.t("Email *")}
                                  </Label>
                                  <SafeField
                                    name="email"
                                    type="text"
                                    
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.email && touched.email
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="email"
                                  />
                                  <ErrorMessage
                                    name="email"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                             
                              <Col md="3">
                               <PhoneInputField
                                                label="Mobile"
                                                name="mobile"
                                                value={values.mobile}
                                                setFieldValue={setFieldValue}
                                                error={errors.mobile}
                                                touched={touched.mobile}
                                                country="ca"
                                                required={true}
                                              />
                                
                              </Col>
                              <Col md="3">
                               <PhoneInputField
                                  label="Secondary Phone"
                                  name="phone"
                                  value={values.phone}
                                  setFieldValue={setFieldValue}
                                  error={errors.phone}
                                  touched={touched.phone}
                                  country="ca"
                                  required={false}
                                />
                               
                              </Col>
                              <Col md="2">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="phoneExt">
                                    {this.props.t("Ext")}
                                  </Label>
                                  <SafeField
                                    name="phoneExt"
                                    type="text"
                                    //value={values.phone}
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.phoneExt && touched.phoneExt
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="phoneExt"
                                  />
                                  <ErrorMessage
                                    name="phoneExt"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col> 
                              <Col md="3">
                               <LeadTypeOption />
                              </Col>

                              <Col md="3">
                                    <LeadStatusOption />
                               
                              </Col>  
                              
                              <Col md="3">
                                    <LeadStageOption />
                              </Col> 
                              <Col md="3">
                              <OtherDropdowns
                                name="group"
                                label="Group"
                               fieldName="Lead:Group"
                              />
                              </Col>
                              <Col md="3">
                              <LeadSourceOption />
                              </Col>    
                              <Col md="4">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="approxDealValue">
                                    {this.props.t("Deal Value")}
                                  </Label>
                                      <CurrencyInput
                                            id="approxDealValue"
                                            name="approxDealValue"
                                            className="form-control"
                                            decimalsLimit={2}
                                            onValueChange={(value) => {
                                              setFieldValue('approxDealValue', value);
                                            }}
                                        />
                                 
                                </FormGroup>
                              </Col>
                             
                                 
                            
                            </Row>
                    
                            <Row>
                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="notes">
                                    {this.props.t("Notes ")}
                                  </Label>
                                  <SafeField
                                    name="notes"
                                    onChange={handleChange}
                                    as="textarea"

                                    className="form-control"

                                    id="notes"

                                  />
                                </FormGroup>
                              </Col>



                            </Row>






                            <div><SaveButton>{this.props.t("Save")}</SaveButton>{ " " } <RsLink onClick={toggleConvertLead}>Close</RsLink></div>

                          </Form>
                        )}
                      </Formik>
                    
      </React.Fragment>
    )
  }
}

ConvertToLead.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  error: PropTypes.any,
  toggleConvertLead:PropTypes.object,
  lead: PropTypes.object,
}
const mapDispatchToProps = dispatch => ({
  
 })
export default connect('',mapDispatchToProps)(withTranslation()(ConvertToLead))
